window.addEventListener("turbolinks:load", () => {
  rangeInput =
    $("input[type=range]").each((i, el) => {
      el.style.background = 'linear-gradient(to right, #F05300 0%, #F05300 ' + el.value + '%, #cfd8dc ' + el.value + '%, #cfd8dc 100%)'

      el.oninput = () => {
        el.style.background = 'linear-gradient(to right, #F05300 0%, #F05300 ' + el.value + '%, #cfd8dc ' + el.value + '%, #cfd8dc 100%)'
      }
  })
})
